import React from 'react';
import styles from './SaleDetailsForm.module.scss';
import {IHotelDetailsWithTerms} from '../hotelDetailsForm/HotelDetailsForm';
import HotelInfo
  from 'gui/pages/mainRouter/pages/ad/components/adHotel/components/firstStage/components/hotelDetailsCard/components/hotelInfo';
import {generateHotelTitle} from 'gui/components/listPage/components/ad/components/adHotel';
import AdStreet from '../../../../listPage/components/ad/components/adStreet/AdStreet';
import AbstractSaleDetailsForm from '../../../commons/editor/components/abstractSaleDetailsForm';
import {ISaleDetails} from 'data/interfaces/products';


interface ISaleDetailsFormProps {
  onSubmit: (formValues) => Promise<any>;
  hotelDetails?: IHotelDetailsWithTerms;
  saleDetails?: ISaleDetails;
  setSubmitRef?: any;

  commonFormComponents?: any;
}

const SaleDetailsForm = (props: ISaleDetailsFormProps) => {
  return (<AbstractSaleDetailsForm
    {...props}
    currency={props.hotelDetails.currency}
    changePrice={props.hotelDetails.changePrice}
    valuePrice={props.hotelDetails.totalHotelPaidPrice}
    commonFormComponents={props.commonFormComponents}
    infoComponent={<HotelInfo
      product={props as any}
      title={generateHotelTitle({product: props})}
      className={styles.hotelInfo}
      additionalDetails={<>
        <AdStreet placeDetails={props.hotelDetails.hotel}/>
      </>}
    />}
    setSubmitRef={props.setSubmitRef}
    saleDetails={props.saleDetails}
    onSubmit={props.onSubmit}
  />);
};

SaleDetailsForm.defaultProps = {
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  HotelDetails: {},
  saleDetails: {},
  setSubmitRef: () => {
  },
  commonFormComponents: () => null,
};
export default React.memo(SaleDetailsForm);
